export default __webpack_public_path__ + "static/FKGroteskNeue-Regular-81330a05cc770d2aa6afc879106c82fb.woff2";